import React from "react";

class Footer extends React.Component{

    render(){
        return <div>
        <span>designed By {this.props.value}</span>
        
        </div>
    };
}
export default Footer;